module.exports = __webpack_public_path__ + "img/umi.57d5231f.jpg";